import React from "react";
import { useTranslation } from "react-i18next";
import Toggle from "components/form/toggle/Toggle";
import DefaultsTableLayout from "./DefaultsTableLayout";
import "./salesChannelTable.scss";

interface ISalesChannelState {
  onlineStoreEnabled?: boolean;
  online_store?: boolean;
}

interface ISalesChannelTableProps {
  state: ISalesChannelState;
  setState: React.Dispatch<React.SetStateAction<ISalesChannelState>>;
  /** When true, all toggles in this table are disabled. */
  togglesDisabled?: boolean;
}

export default function SalesChannelTable(props: ISalesChannelTableProps) {
  const { t } = useTranslation();
  const { state, setState, togglesDisabled } = props;

  return (
    <DefaultsTableLayout tooltipId="sales-channel-default-value-tooltip">
      {/* Online Store */}
      <tr className="sales-channel-defaults-table-row">
        <td>{t("Online store")}</td>

        <td>
          <Toggle
            id="online_store"
            checked={state.online_store}
            onChange={() => setState(prev => ({ ...prev, online_store: !prev.online_store }))}
            disabled={togglesDisabled ?? false}
          />
        </td>
      </tr>
    </DefaultsTableLayout>
  );
}
